/* eslint-disable prettier/prettier */
import * as yup from 'yup'
import { createDataRef, createDataSchema, createPropertiesSchema } from '../schemaUtils'
import { ImageSchema } from '../media/Image.schema'
import { BackgroundMediaSchema } from '../media/Media.schema'

const pageBackgroundDataRef = createDataRef({ BackgroundMedia: BackgroundMediaSchema }).nullable()

export const basePageDataSchema = 	yup.object({
	title: yup
		.string()
		.min(1)
		.max(100),
	hideTitle: yup.boolean(),
	icon: yup.string(),
	windowTitle: yup
		.string()
		.min(1)
		.max(512),
	descriptionSEO: yup.string().max(1024),
	metaKeywordsSEO: yup.string().max(512),
	pageTitleSEO: yup.string(),
	pageUriSEO: yup.string(),
	hidePage: yup.boolean(),
	underConstruction: yup.boolean(),
	tpaApplicationId: yup.number(),
	managingAppDefId: yup.string().nullable(),
	tpaPageId: yup.string(),
	pageSecurity: yup
		.object().shape({
			requireLogin: yup.boolean(),
			passwordDigest: yup.string().notRequired(),
			dialogLanguage: yup.string().notRequired(),
		})
		.nullable()
		.default({
			requireLogin: false,
			passwordDigest: '',
			dialogLanguage: '',
		}),
	indexable: yup.boolean().default(true),
	mobileHidePage: yup.boolean().nullable(),
	pageBackgrounds: yup.object().shape({
		desktop: yup.object().shape({
			custom: yup.boolean(),
			ref: pageBackgroundDataRef,
			isPreset: yup.boolean(),
		}),
		mobile: yup.object().shape({
			custom: yup.boolean(),
			mediaSizing: yup
				.mixed<'document' | 'viewport'>()
				.oneOf(['document', 'viewport'])
				.default('viewport'),
			ref: pageBackgroundDataRef,
			isPreset: yup.boolean(),
		}),
	}),
	isLandingPage: yup.boolean().default(false),
	isMobileLandingPage: yup.boolean().default(false),
	isPopup: yup.boolean().default(false),
	translationData: yup.object().shape({
		uriSEOTranslated: yup.boolean(),
	}),
	ogImageRef: createDataRef({ Image: ImageSchema }).notRequired(),
	advancedSeoData: yup.string().notRequired(),
	characterSets: yup.array(yup.string()).notRequired(),
})

export const pageDataSchema = createDataSchema(
	'Page',
	basePageDataSchema
)

// TODO need to write it fully
const viewModePropertiesSchema = yup.object().shape({
	minHeight: yup.number(),
	popup: yup.object().shape({
		closeOnOverlayClick: yup.boolean().default(true),
	}).notRequired()
})

export const pagePropertiesSchema = createPropertiesSchema(
	'PageProperties',
	yup.object({
		desktop: viewModePropertiesSchema,
		mobile: viewModePropertiesSchema,
	})
)
